// extracted by mini-css-extract-plugin
export default {"container":"CalloutBox-module__container__jZDJU"};